import React from 'react';

interface IconProps {
  size?: number;
  className?: string;
  strokeWidth?: number;
}

export const LockIcon: React.FC<IconProps> = ({ size = 12, strokeWidth = 2 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={strokeWidth}>
    <rect x="3" y="11" width="18" height="11" rx="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>
);

export const BankIcon: React.FC<IconProps> = ({ size = 20, strokeWidth = 1.5 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round">
    <path d="M3 9.5 12 4l9 5.5" />
    <path d="M5 10v8M10 10v8M14 10v8M19 10v8" />
    <path d="M3 20h18" />
  </svg>
);

export const WhatsAppIcon: React.FC<{ size?: number }> = ({ size = 26 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="white">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
  </svg>
);

export const WhatsAppIconSmall: React.FC<{ size?: number }> = ({ size = 13 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
  </svg>
);

// Emblema neutro (balanza de la justicia). Marca genérica del SaaS; cada
// estudio podrá subir su propio logo más adelante.
// Isotipo Tabularis (según logos/logo1.png): hojas/registros apilados con la "T"
// recortada en el documento y la esquina doblada dorada. Las hojas usan
// currentColor (se adaptan al fondo: marino sobre claro, claro sobre oscuro) y la
// "T" es un recorte (máscara) que deja ver el fondo, para que funcione en claro y
// oscuro. La esquina dorada es fija.
// Variante monocroma del isotipo, hereda el color con currentColor. La usa la
// cabecera de Chatbularis (AsistenteLegal); el resto del producto muestra
// LogoLockup. Es la geometría del isotipo de marca y sirve para cualquier
// superficie oscura que aparezca más adelante.
export const LogoSVG: React.FC<{ size?: number }> = ({ size = 50 }) => (
  <svg width={size} height={size} viewBox="0 0 44 44" fill="none" style={{ flexShrink: 0 }}>
    <defs>
      <mask id="tab-t-cut">
        <rect width="44" height="44" fill="white" />
        <path d="M18 15 H30 V19.5 H26.5 V29 H21.5 V19.5 H18 Z" fill="black" />
      </mask>
    </defs>
    <g mask="url(#tab-t-cut)">
      {/* hojas de atrás (dan profundidad al stack) */}
      <rect x="7" y="12" width="22" height="28" rx="2.6" fill="currentColor" opacity="0.4" />
      <rect x="10" y="9" width="22" height="28" rx="2.6" fill="currentColor" opacity="0.68" />
      {/* hoja frontal con la esquina superior derecha doblada */}
      <path d="M15.6 6 H29 L35 12 V31.4 A2.6 2.6 0 0 1 32.4 34 H15.6 A2.6 2.6 0 0 1 13 31.4 V8.6 A2.6 2.6 0 0 1 15.6 6 Z" fill="currentColor" />
    </g>
    {/* pliegue dorado (fuera de la máscara, siempre dorado) */}
    <path d="M29 6 L35 12 H30.6 A1.6 1.6 0 0 1 29 10.4 Z" fill="#C9A227" />
  </svg>
);

// Chatbularis: el mismo isotipo, un poco más chico y hacia arriba a la
// izquierda, con la cabeza de un robot montada sobre la esquina inferior
// derecha. Es el mismo dibujo de los íconos de la app (chatbularis-*.png):
// se distingue de Tabularis en la pantalla de inicio sin dejar de ser la marca.
export const LogoChatbularisSVG: React.FC<{ size?: number }> = ({ size = 50 }) => (
  <svg width={size} height={size} viewBox="0 0 44 44" fill="none" style={{ flexShrink: 0 }}>
    <defs>
      <mask id="chat-t-cut">
        <rect width="44" height="44" fill="white" />
        <path d="M18 15 H30 V19.5 H26.5 V29 H21.5 V19.5 H18 Z" fill="black" />
      </mask>
    </defs>
    <g transform="translate(-2 -2) scale(0.92)" color="#10204A">
      <g mask="url(#chat-t-cut)">
        <rect x="7" y="12" width="22" height="28" rx="2.6" fill="#1E4FA3" />
        <rect x="10" y="9" width="22" height="28" rx="2.6" fill="#16307A" />
        <path d="M15.6 6 H29 L35 12 V31.4 A2.6 2.6 0 0 1 32.4 34 H15.6 A2.6 2.6 0 0 1 13 31.4 V8.6 A2.6 2.6 0 0 1 15.6 6 Z" fill="currentColor" />
      </g>
      <path d="M29 6 L35 12 H30.6 A1.6 1.6 0 0 1 29 10.4 Z" fill="#C9A227" />
    </g>
    {/* robot: contorno navy sobre blanco, ojos y antena dorados */}
    <g transform="translate(25 24.5) scale(0.095)" strokeLinecap="round" strokeLinejoin="round">
      <g stroke="#fff" strokeWidth="40" fill="#fff">
        <line x1="100" y1="24" x2="100" y2="52" /><rect x="30" y="52" width="140" height="112" rx="32" />
        <rect x="12" y="88" width="20" height="40" rx="8" /><rect x="168" y="88" width="20" height="40" rx="8" />
      </g>
      <line x1="100" y1="30" x2="100" y2="52" stroke="#10204A" strokeWidth="16" />
      <circle cx="100" cy="22" r="12" fill="#C9A227" stroke="#10204A" strokeWidth="10" />
      <rect x="16" y="92" width="14" height="32" rx="6" fill="#fff" stroke="#10204A" strokeWidth="12" />
      <rect x="170" y="92" width="14" height="32" rx="6" fill="#fff" stroke="#10204A" strokeWidth="12" />
      <rect x="30" y="52" width="140" height="112" rx="32" fill="#fff" stroke="#10204A" strokeWidth="16" />
      <circle cx="74" cy="100" r="14" fill="#C9A227" /><circle cx="126" cy="100" r="14" fill="#C9A227" />
      <path d="M78 134 Q100 146 122 134" fill="none" stroke="#10204A" strokeWidth="12" />
    </g>
  </svg>
);

// Lockup oficial de la marca: es logos/logo1.png tal cual (isotipo + palabra),
// solo con el fondo cuadriculado del export original convertido en transparencia.
// Es el logo de toda la aplicación. El arte es navy sobre transparente, así que
// necesita una superficie clara detrás — hoy todas lo son, incluido el panel
// (.login-box usa --dark-3 #EAF0F9 y .panel-topbar es blanco; los nombres de esas
// variables vienen de un tema oscuro anterior y engañan).
export const LogoLockup: React.FC<{ height?: number }> = ({ height = 30 }) => (
  <img
    src="/logo-lockup.png"
    alt="Tabularis"
    style={{ height, width: 'auto', display: 'block', flexShrink: 0 }}
  />
);
